import axios from "@/api/config";

const user = {
  getUserById(data) {
    return axios.get(`${process.env.BASE_URL}/user/getUser/` + data, {});
  },
  getUser(data) {
    return axios.get(`${process.env.BASE_URL}/user/getUser`, { params: data });
  },
  pageList(data) {
    return axios.post(`${process.env.BASE_URL}/user/pageList`, data);
  },
  addUser(data) {
    return axios.post(`${process.env.BASE_URL}/user/addUser`, data);
  },
  updateUser(data) {
    return axios.put(`${process.env.BASE_URL}/user/updateUser`, data);
  },
  deleteUser(data) {
    return axios.delete(`${process.env.BASE_URL}/user/deleteUser`, {
      data: data
    });
  },
  exportExcel(data) {
    return axios.get(`${process.env.BASE_URL}/user/exportExcel`, {
      params: data
    });
  },
  importData() {
    return axios.post(`${process.env.BASE_URL}/user/importData`, data);
  },
  //直播相关
  addLiveConfiguration(data) {
    return axios.post(
      `${process.env.BASE_URL}/liveConfiguration/addLiveConfiguration`,
      data
    );
  },
  //直播相关查询
  getLiveConfiguration(data) {
    return axios.get(
      `${process.env.BASE_URL}/liveConfiguration/getLiveConfiguration `,
      { params: data }
    );
  },
  //直播相关新增
  updateLiveConfiguration(data) {
    return axios.put(
      `${process.env.BASE_URL}/liveConfiguration/updateLiveConfiguration `,
      data
    );
  },
  //按钮权限
  getButtonRoleResourceList(data) {
    return axios.get(
      `${process.env.BASE_URL}/system/getButtonRoleResourceList`,
      { params: data }
    );
  },
  getToken() {
    return axios.get(`${process.env.BASE_URL}/dashboard/getToken`);
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/api/user.js